import React from 'react';

import {
  FormGroup,
  Input,
  Button
} from 'reactstrap';

import FieldError from "../../../../../../helper/FieldError";

const WorkflowHttpRequestOutputStageFormFileItemAttributes = props => {
  const {
    fileItem,
    callbacks: {
      onChangeFileItem: callbackOnChangeFileItem
    }
  } = props;

  const onChangeFileItem = (event, key) => {
    let _fileItem = { ... fileItem }

    if(event.target.type == 'file'){
      _fileItem[key] = event.target.files[0]
    } else {
      _fileItem[key] = event.target.value
    }

    if(_.isFunction(callbackOnChangeFileItem)){
      callbackOnChangeFileItem(_fileItem, fileItem.custom_id)
    }
  }

  return (
    <tr>
      <td>
        <FormGroup>
          <FieldError errors={ _.get(fileItem, 'errors.name') }>
            <Input
              type='text'
              value={ fileItem.name }
              required
              onChange={ e => onChangeFileItem(e, 'name') }
            />
          </FieldError>
        </FormGroup>
      </td>

      <td className='text-center'>
        <Button
          outline
          color='danger'
          size='xs'
          onClick={ () => onChangeFileItem({ target: { value: true } }, '_destroy') }
        >
          <i className='fas fa-trash'></i>
        </Button>
      </td>
    </tr>
  )
}

export default WorkflowHttpRequestOutputStageFormFileItemAttributes;
